import React, { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { name: "Home", to: "/" },
    { name: "About", to: "/about" },
    { name: "Dog Grooming", to: "/grooming" },
    { name: "Gallery", to: "/galeri" },
    { name: "Visit Us & Contact", to: "/contact" },
    { name: "Bookings", external: true, to: "https://bookings.gettimely.com/furlissimoptyltd/bb/book", bg: "#F5A19D" },
  ];

  return (
    <nav
      className="sticky top-0 z-50 shadow-lg font-[Quicksand]"
      style={{
        backgroundImage: "url('/assets/images/bgcolor1.png')",
        height: "100px",
      }}
    >
      <div className="max-w-6xl mx-auto px-2 md:px-4 flex items-center justify-between h-full">
        <div className="flex-shrink-0">
          <img
            src="/assets/images/logo.png"
            alt="Furlissimo"
            className="rounded-full"
            style={{ width: "160px", height: "70px" }}
          />
        </div>

        {/* Menu desktop */}
        <div className="hidden md:flex items-center gap-4">
          {menuItems.map((item, index) =>
            item.external ? (
              <a
                key={index}
                href={item.to}
                target="_blank"
                rel="noopener noreferrer"
                className={`px-6 py-2 rounded-lg shadow-md text-[17px] font-bold transition text-center bg-white hover:bg-gray-100 text-gray-800`}
              >
                {item.name}
              </a>
            ) : (
              <NavLink
                key={index}
                to={item.to}
                end
                className={({ isActive }) =>
                  `px-6 py-2 rounded-lg shadow-md text-[17px] font-bold transition text-center ${
                    isActive
                      ? "bg-[#F5A19D] text-white"
                      : "bg-white hover:bg-gray-100 text-gray-800"
                  }`
                }
              >
                {item.name}
              </NavLink>
            )
          )}
        </div>

        {/* Tombol menu mobile */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <FiX size={30} /> : <FiMenu size={30} />}
          </button>
        </div>
      </div>

      {/* Menu mobile */}
      {isOpen && (
        <div className="absolute top-[100px] left-0 w-full bg-white flex flex-col items-center shadow-lg md:hidden gap-3 py-4">
          <div className="max-w-6xl mx-auto px-6 md:px-12 flex flex-col items-center gap-3 w-full">
            {menuItems.map((item, index) =>
              item.external ? (
                <a
                  key={index}
                  href={item.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 rounded-xl shadow-md text-[18px] font-bold transition text-center w-[90%] bg-gray-100 hover:bg-gray-200 text-gray-800"
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </a>
              ) : (
                <NavLink
                  key={index}
                  to={item.to}
                  end
                  className={({ isActive }) =>
                    `px-6 py-3 rounded-xl shadow-md text-[18px] font-bold transition text-center w-[90%] ${
                      isActive
                        ? "bg-[#F5A19D] text-white"
                        : "bg-gray-100 hover:bg-gray-200 text-gray-800"
                    }`
                  }
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </NavLink>
              )
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
